// extracted by mini-css-extract-plugin
module.exports = {"bounceQuestionMarkIcon":"LeadFormModal2_bounceQuestionMarkIcon__jelgi"};